// extracted by mini-css-extract-plugin
export default {"component":"JackpotTicker__component--slots-bAUvv","content":"Skeleton__content--slots-mMGfN"};